import { Link } from "react-router-dom";

export function NotFoundPage(): JSX.Element {
  return (
    <div
      className="stack"
      style={{
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "1.5rem",
        background: "var(--color-bg)",
        gap: ".75rem",
      }}
    >
      <div
        style={{
          fontSize: "4.5rem",
          fontWeight: 900,
          letterSpacing: "-.05em",
          color: "var(--color-coral)",
          lineHeight: 1,
        }}
      >
        404
      </div>
      <p style={{ margin: 0, fontSize: "1.125rem", fontWeight: 900 }}>Página não encontrada</p>
      <p style={{ margin: 0, fontSize: ".8125rem", fontWeight: 600, color: "var(--color-ink-2)", maxWidth: "22rem" }}>
        A URL que você tentou abrir não existe ou você não tem permissão.
      </p>
      <Link to="/" className="btn btn--primary" style={{ marginTop: ".5rem" }}>
        Voltar para o início
      </Link>
    </div>
  );
}
